module.exports = __webpack_public_path__ + "img/Payara.70ba54ee.png";